import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "region-teaser__body" }
const _hoisted_3 = {
  key: 0,
  class: "region-teaser__title"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "region-teaser__selected-icon" }, null, -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["region-teaser", _ctx.isSelected ? 'is-selected' : '']),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onSelect(_ctx.id,_ctx.isMainRegion,_ctx.name)))
  }, [
    _createElementVNode("div", {
      class: "region-teaser__img",
      innerHTML: _ctx.image
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.name)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.name), 1))
        : _createCommentVNode("", true),
      (_ctx.text)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "region-teaser__text",
            innerHTML: _ctx.text
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["region-teaser__selected", _ctx.isSelected ? 'is-selected' : ''])
    }, [
      _hoisted_5,
      (_ctx.isSelected)
        ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.translate('shop.ticket.configuration.selected')), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.translate('shop.ticket.configuration.select')), 1))
    ], 2)
  ], 2))
}